import React from "react"
import Footer_Logo from '../asset/Footer_Logo.jpg'
import { SocialIcon } from 'react-social-icons/component'
import 'react-social-icons/facebook'
import 'react-social-icons/instagram'
import 'react-social-icons/whatsapp'
import 'react-social-icons/youtube'
import 'react-social-icons/twitter'
import 'react-social-icons/tiktok'

const Footer = () => <footer className="page-footer font-small blue pt-4">
    <div className="container-fluid text-center text-md-left">
        <div className="row">
            <div className="col-md-6 mt-md-0 mt-3">
                <img src={Footer_Logo} alt="" height='90px' />
                <p>Bentley Motors Limited</p>
                <br/>
                <SocialIcon url="https://www.facebook.com/"/>&nbsp;&nbsp;<SocialIcon url="https://www.instagram.com/"/>&nbsp;&nbsp;<SocialIcon url="https://www.whatsapp.com/"/>&nbsp;&nbsp;<SocialIcon url="https://www.youtube.com/"/>&nbsp;&nbsp;<SocialIcon url="https://www.twitter.com/"/>&nbsp;&nbsp;<SocialIcon url="https://www.tiktok.com/"/>&nbsp;&nbsp;
            </div>

            <hr className="clearfix w-100 d-md-none pb-0"/>

            <div className="col-md-3 mb-md-0 mb-3">
                <br />
                <br />
                <h5 className="text-uppercase">MODELS</h5>
                <ul className="list-unstyled">
                    <li>Bentayga Extended Wheelbase</li>
                    <li>Flying Spur</li>
                    <li>Continental GT</li>
                    <li>Continental GTC</li>
                    <li>Mulline</li>
                </ul>
            </div>

            <div className="col-md-3 mb-md-0 mb-3">
                <br />
                <br />
                <h5 className="text-uppercase">OWNERSHIP</h5>
                <ul className="list-unstyled">
                    <li>Services</li>
                    <li>Technology</li>
                    <li>Finance Services</li>
                    <li>Club and Associations</li>
                </ul>
            </div>
        </div>
    </div>

    <div className="footer-copyright text-center py-3">© Copyright Bentley Motors 2023 <br />
    <p>Registered Office: Pyms Lane, Crewe, Cheshire, CW1 3PL, England. Registered in England: Number 992897</p>
    </div>

</footer>

export default Footer